import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { FeatureService } from 'app/shared/services/feature-service';
import { autoinject, View } from 'aurelia-framework';

// INFO [Matt] These are properties we don't warn the developer of accessing,
//  e.g. properties accessed internally by Aurelia.
const PROPERTY_IGNORELIST = [/^__/];

@autoinject()
export class FeatureViewEngineHooks {
    constructor(protected readonly service: FeatureService, protected readonly logger: AppLogger) { }
    beforeBind(view: View) {
        const { logger } = this;
        Object.assign(view.overrideContext, {
            $features: new Proxy(this.service.enabledFeatures, {
                get(target: any, property: string) {
                    if(!Reflect.has(target, property) && !PROPERTY_IGNORELIST.some((re) => re.test(property))) {
                        logger.warn(`Feature ${property} doesn't exist. Did you add it to the FeatureSet? Is it spelled correctly?`);
                    }
                    return Reflect.get(target, property);
                }
            })
        });
    }
}

